
























import Vue from 'vue';
export default Vue.extend({
  props: {
    hintText: {
      type: String,
      default: 'hint',
    },
    maxWidth: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'top',
    },
  },
  data(): { hasCursor: boolean; clicked: boolean } {
    return {
      hasCursor: false,
      clicked: false,
    };
  },
  methods: {
    onMouseEnter() {
      this.hasCursor = true;
    },
    onMouseLeave() {
      this.hasCursor = false;
    },
    onMouseClick() {
      this.clicked = !this.clicked;
    },
  },
});
